import React from 'react';
import { cx } from 'linaria';
import { SwiperSlide } from 'swiper/react';
import { Banner } from './banner';
import { BannersCarouselItemProps } from '../types';
import { BannersCarouselItemWrapper } from '../styles';

export const BannersCarouselItem: React.FC<BannersCarouselItemProps> = props => {
  const {
    banner: { cdnUrl, pictureUrl, targetUrl },
    onClick,
    onView,
    ord,
    className,
    targetBlank,
  } = props;

  return (
    <SwiperSlide className={cx(BannersCarouselItemWrapper, className)}>
      <Banner {...{ cdnUrl, pictureUrl, targetUrl, ord, onClick, onView, targetBlank }} />
    </SwiperSlide>
  );
};
